(function(){
  function init(){
    var root=document.querySelector('.vsp');
    if(!root||root.dataset.vsDesignRefinement==='true') return;
    root.dataset.vsDesignRefinement='true';

    var nav=root.querySelector('.vs-nav');
    var role=root.querySelector('.vsp-role');
    var signature=root.querySelector('.vsp-signature');
    var related=root.querySelector('.vsp-related-framework');

    if(role){
      role.classList.remove('is-visible');
      if('IntersectionObserver' in window){
        var roleObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.classList.add('is-visible');
              roleObserver.unobserve(entry.target);
            }
          });
        },{threshold:.08,rootMargin:'0px 0px -10% 0px'});
        roleObserver.observe(role);
      }else{
        role.classList.add('is-visible');
      }
    }
    var contact=root.querySelector('.vs-contact');

    var isStudio=root.getAttribute('data-service')==='the-studio';
    var signatureCards=root.querySelectorAll('.vsp-signature .vsp-three article, .vsp-signature .vsp-four article, .vsp-signature .vsp-production-models article');
    var relatedCards=root.querySelectorAll('.vsp-related-framework .vsp-related-card');

    if(signature){
      signature.classList.remove('is-framework-visible');
      if('IntersectionObserver' in window){
        var signatureIntroObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.classList.add('is-framework-visible');
              signatureIntroObserver.unobserve(entry.target);
            }
          });
        },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
        signatureIntroObserver.observe(signature);
      }else{
        signature.classList.add('is-framework-visible');
      }
    }

    if(signatureCards.length){
      var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      signatureCards.forEach(function(card,index){
        card.style.setProperty('--vsp-card-delay',(index*90)+'ms');
      });

      if(reduceMotion){
        signatureCards.forEach(function(card){card.classList.add('is-service-visible');});
      }else if('IntersectionObserver' in window){
        var studioCardObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.classList.add('is-service-visible');
              studioCardObserver.unobserve(entry.target);
            }
          });
        },{threshold:.16,rootMargin:'0px 0px -8% 0px'});

        signatureCards.forEach(function(card){studioCardObserver.observe(card);});
      }else{
        signatureCards.forEach(function(card){card.classList.add('is-service-visible');});
      }
    }
    if(relatedCards.length){
      var relatedReduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      relatedCards.forEach(function(card,index){
        card.style.setProperty('--vsp-related-card-delay',(index*90)+'ms');
      });

      if(relatedReduceMotion){
        relatedCards.forEach(function(card){card.classList.add('is-service-visible');});
      }else if('IntersectionObserver' in window){
        var relatedCardObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.classList.add('is-service-visible');
              relatedCardObserver.unobserve(entry.target);
            }
          });
        },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
        relatedCards.forEach(function(card){relatedCardObserver.observe(card);});
      }else{
        relatedCards.forEach(function(card){card.classList.add('is-service-visible');});
      }
    }

    var lastY=window.scrollY||0;
    var raf=0;

    function clamp01(value){
      return Math.max(0,Math.min(1,value));
    }

    function updateHeader(){
      if(!nav) return;
      var y=window.scrollY||0;
      var delta=y-lastY;

      if(window.innerWidth>680){
        if(y<80) nav.classList.remove('is-scroll-hidden');
        else if(delta>8) nav.classList.add('is-scroll-hidden');
        else if(delta<-6) nav.classList.remove('is-scroll-hidden');
      }else{
        nav.classList.remove('is-scroll-hidden');
      }

      lastY=y;
    }

    function updateSurfaceFades(){
      var vh=window.innerHeight||document.documentElement.clientHeight;

      if(window.innerWidth<=1100){
        if(role) role.style.setProperty('--vsp-role-overlay-opacity','0');
        if(signature){
          signature.style.setProperty('--vsp-signature-overlay-opacity','0');
          signature.classList.add('is-colored');
        }
        if(related){
          related.style.setProperty('--vsp-related-overlay-opacity','0');
          related.classList.add('is-blue');
        }
        if(contact) contact.style.setProperty('--vsp-contact-dissolve','0');
        return;
      }

      /* Same timing as homepage WHY VOLUME & SCALE:
         outgoing service color dissolves to ivory. */
      if(role){
        var r=role.getBoundingClientRect();
        var rStart=vh*.98;
        var rEnd=vh*.48;
        var rProgress=clamp01((rStart-r.top)/(rStart-rEnd));
        role.style.setProperty('--vsp-role-overlay-opacity',(1-rProgress).toFixed(3));
      }

      /* Same timing/easing as homepage Three Disciplines:
         ivory overlay disappears and service color takes over. */
      if(signature){
        var s=signature.getBoundingClientRect();
        var sStart=vh*1.20;
        var sEnd=vh*.08;
        var sProgress=clamp01((sStart-s.top)/(sStart-sEnd));
        var sEase=sProgress*sProgress*sProgress*(sProgress*(sProgress*6-15)+10);
        signature.style.setProperty('--vsp-signature-overlay-opacity',(1-sEase).toFixed(3));

        if(sProgress>.02){
          signature.classList.add('is-colored');
        }
      }

      if(related){
        var f=related.getBoundingClientRect();
        var fStart=vh*1.20;
        var fEnd=vh*.08;
        var fProgress=clamp01((fStart-f.top)/(fStart-fEnd));
        var fEase=fProgress*fProgress*fProgress*(fProgress*(fProgress*6-15)+10);
        related.style.setProperty('--vsp-related-overlay-opacity',(1-fEase).toFixed(3));
        if(fProgress>.02){
          related.classList.add('is-blue');
        }
      }

      if(contact){
        var c=contact.getBoundingClientRect();
        var cProgress=clamp01((vh*.98-c.top)/(vh*.68));
        var cEase=cProgress*cProgress*(3-2*cProgress);
        contact.style.setProperty('--vsp-contact-dissolve',(1-cEase).toFixed(4));
      }
    }

    function update(){
      raf=0;
      updateHeader();
      updateSurfaceFades();
    }

    function requestUpdate(){
      if(raf) return;
      raf=requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll',requestUpdate,{passive:true});
    window.addEventListener('resize',requestUpdate,{passive:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }

  document.addEventListener('shopify:section:load',function(){
    var root=document.querySelector('.vsp');
    if(root) root.dataset.vsDesignRefinement='false';
    init();
  });
})();